export default "__VITE_ASSET__DQ_2$T8$__"